/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BidManagementListOrderResponse } from './BidManagementListOrderResponse';

export type BidManagementListOrderResponseApiRespoonse = {
    data?: BidManagementListOrderResponse;
    status?: BidManagementListOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BidManagementListOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

